var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { format } from 'date-fns';
import { useCallback } from 'react';
import { Tooltip } from '@hn-ui/tooltips';
import { styled } from 'styled-components';
import { GradeInfo, Grades } from '../../../../../landing/models/GradeInfo';
import { PieBase } from './PieBase';
import { TestPositionColor } from '../../../Common/colors';
import { Title } from '../../../Common';
import { HelpIcon, SubHeader } from '../Common';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-ohh1kt" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  justify-content: flex-start;\n  width: 100%;\n"], ["\n  display: flex;\n  flex-flow: column;\n  justify-content: flex-start;\n  width: 100%;\n"])));
var TitleContainer = styled.div.withConfig({ displayName: "TitleContainer", componentId: "sc-1x5djz6" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  margin-bottom: 16px;\n"], ["\n  display: flex;\n  margin-bottom: 16px;\n"])));
var Body = styled.div.withConfig({ displayName: "Body", componentId: "sc-83731e" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  /* margin-bottom: 4px; */\n"], ["\n  display: flex;\n  justify-content: space-between;\n  /* margin-bottom: 4px; */\n"])));
var LeftPart = styled.div.withConfig({ displayName: "LeftPart", componentId: "sc-m9l7ux" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  margin-right: 38px;\n"], ["\n  display: flex;\n  flex-flow: column;\n  margin-right: 38px;\n"])));
var RightPart = styled.div.withConfig({ displayName: "RightPart", componentId: "sc-d2ipdj" })(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n"], ["\n  display: flex;\n  flex-flow: column;\n"])));
var ScSubHeader = styled(SubHeader).withConfig({ displayName: "ScSubHeader", componentId: "sc-ty4hdm" })(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin: 0 0 4px 0;\n"], ["\n  margin: 0 0 4px 0;\n"])));
var InfoText = styled.p.withConfig({ displayName: "InfoText", componentId: "sc-vr6t9d" })(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  font-size: 13px;\n  line-height: 16px;\n  letter-spacing: -0.2px;\n  color: ", ";\n\n  margin-bottom: 12px;\n"], ["\n  font-size: 13px;\n  line-height: 16px;\n  letter-spacing: -0.2px;\n  color: ", ";\n\n  margin-bottom: 12px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.blackText;
});
var PieContainer = styled.div.withConfig({ displayName: "PieContainer", componentId: "sc-idgnwz" })(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  margin-top: 28px;\n"], ["\n  margin-top: 28px;\n"])));
var LegendContainer = styled.div.withConfig({ displayName: "LegendContainer", componentId: "sc-hnyznr" })(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n"], ["\n  display: flex;\n  justify-content: center;\n"])));
var SquareContainer = styled.div.withConfig({ displayName: "SquareContainer", componentId: "sc-1gsvtfq" })(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  &:not(:last-child) {\n    margin-right: 16px;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  &:not(:last-child) {\n    margin-right: 16px;\n  }\n"])));
var Square = styled.span.withConfig({ displayName: "Square", componentId: "sc-1v5wnyf" })(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  border-radius: 2px;\n  margin-right: 4px;\n  background-color: ", ";\n"], ["\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  border-radius: 2px;\n  margin-right: 4px;\n  background-color: ", ";\n"])), function (_a) {
    var color = _a.color;
    return color;
});
var SquareText = styled.span.withConfig({ displayName: "SquareText", componentId: "sc-k638o3" })(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  font-weight: bold;\n  font-size: 10px;\n  line-height: 10px;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  color: ", ";\n"], ["\n  font-weight: bold;\n  font-size: 10px;\n  line-height: 10px;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.blackText;
});
var legends = new Map([
    [
        Grades.PK,
        [
            { grade: Grades.TBD, color: TestPositionColor.TBD },
            { grade: Grades.PK, color: TestPositionColor.MEETS },
            { grade: Grades.K, color: TestPositionColor.EXCEEDS },
            { grade: Grades.G1, color: TestPositionColor.EXCEEDS },
            { grade: Grades.G2, color: TestPositionColor.EXCEEDS },
            { grade: Grades.G3, color: TestPositionColor.EXCEEDS },
            { grade: Grades.G4, color: TestPositionColor.EXCEEDS },
            { grade: Grades.G5, color: TestPositionColor.EXCEEDS },
        ],
    ],
    [
        Grades.K,
        [
            { grade: Grades.TBD, color: TestPositionColor.TBD },
            { grade: Grades.PK, color: TestPositionColor.BELOW },
            { grade: Grades.K, color: TestPositionColor.MEETS },
            { grade: Grades.G1, color: TestPositionColor.EXCEEDS },
            { grade: Grades.G2, color: TestPositionColor.EXCEEDS },
            { grade: Grades.G3, color: TestPositionColor.EXCEEDS },
            { grade: Grades.G4, color: TestPositionColor.EXCEEDS },
            { grade: Grades.G5, color: TestPositionColor.EXCEEDS },
        ],
    ],
    [
        Grades.G1,
        [
            { grade: Grades.TBD, color: TestPositionColor.TBD },
            { grade: Grades.PK, color: TestPositionColor.FAR_BELOW },
            { grade: Grades.K, color: TestPositionColor.BELOW },
            { grade: Grades.G1, color: TestPositionColor.MEETS },
            { grade: Grades.G2, color: TestPositionColor.EXCEEDS },
            { grade: Grades.G3, color: TestPositionColor.EXCEEDS },
            { grade: Grades.G4, color: TestPositionColor.EXCEEDS },
            { grade: Grades.G5, color: TestPositionColor.EXCEEDS },
        ],
    ],
    [
        Grades.G2,
        [
            { grade: Grades.TBD, color: TestPositionColor.TBD },
            { grade: Grades.PK, color: TestPositionColor.FAR_BELOW },
            { grade: Grades.K, color: TestPositionColor.FAR_BELOW },
            { grade: Grades.G1, color: TestPositionColor.BELOW },
            { grade: Grades.G2, color: TestPositionColor.MEETS },
            { grade: Grades.G3, color: TestPositionColor.EXCEEDS },
            { grade: Grades.G4, color: TestPositionColor.EXCEEDS },
            { grade: Grades.G5, color: TestPositionColor.EXCEEDS },
        ],
    ],
    [
        Grades.G3,
        [
            { grade: Grades.TBD, color: TestPositionColor.TBD },
            { grade: Grades.PK, color: TestPositionColor.FAR_BELOW },
            { grade: Grades.K, color: TestPositionColor.FAR_BELOW },
            { grade: Grades.G1, color: TestPositionColor.FAR_BELOW },
            { grade: Grades.G2, color: TestPositionColor.BELOW },
            { grade: Grades.G3, color: TestPositionColor.MEETS },
            { grade: Grades.G4, color: TestPositionColor.EXCEEDS },
            { grade: Grades.G5, color: TestPositionColor.EXCEEDS },
        ],
    ],
    [
        Grades.G4,
        [
            { grade: Grades.TBD, color: TestPositionColor.TBD },
            { grade: Grades.PK, color: TestPositionColor.FAR_BELOW },
            { grade: Grades.K, color: TestPositionColor.FAR_BELOW },
            { grade: Grades.G1, color: TestPositionColor.FAR_BELOW },
            { grade: Grades.G2, color: TestPositionColor.FAR_BELOW },
            { grade: Grades.G3, color: TestPositionColor.BELOW },
            { grade: Grades.G4, color: TestPositionColor.MEETS },
            { grade: Grades.G5, color: TestPositionColor.EXCEEDS },
        ],
    ],
    [
        Grades.G5,
        [
            { grade: Grades.TBD, color: TestPositionColor.TBD },
            { grade: Grades.PK, color: TestPositionColor.FAR_BELOW },
            { grade: Grades.K, color: TestPositionColor.FAR_BELOW },
            { grade: Grades.G1, color: TestPositionColor.FAR_BELOW },
            { grade: Grades.G2, color: TestPositionColor.FAR_BELOW },
            { grade: Grades.G3, color: TestPositionColor.FAR_BELOW },
            { grade: Grades.G4, color: TestPositionColor.BELOW },
            { grade: Grades.G5, color: TestPositionColor.MEETS },
        ],
    ],
]);
var CommonLegend = function (_a) {
    var legend = _a.legend;
    var legendMappedByColor = new Map();
    legend.forEach(function (_a) {
        var _b;
        var grade = _a.grade, color = _a.color;
        var previous = (_b = legendMappedByColor.get(color)) !== null && _b !== void 0 ? _b : [];
        legendMappedByColor.set(color, __spreadArray(__spreadArray([], previous, true), [grade], false));
    });
    var legendCombinedByTestPosition = Array.from(legendMappedByColor, function (_a) {
        var color = _a[0], grades = _a[1];
        return ({
            color: color,
            grades: grades,
        });
    });
    return (_jsx(_Fragment, { children: legendCombinedByTestPosition.map(function (_a) {
            var _b, _c;
            var color = _a.color, grades = _a.grades;
            var lowestGrade = (_b = GradeInfo.get(grades[0])) === null || _b === void 0 ? void 0 : _b.shortName;
            var highestGrade = grades.length > 1
                ? (_c = GradeInfo.get(grades[grades.length - 1])) === null || _c === void 0 ? void 0 : _c.shortName
                : null;
            var displayLegend = highestGrade
                ? lowestGrade + "-" + highestGrade
                : lowestGrade;
            return (_jsxs(SquareContainer, { children: [_jsx(Square, { color: color }, void 0), _jsx(SquareText, { children: displayLegend }, void 0)] }, displayLegend));
        }) }, void 0));
};
var DiagramDistribution = function (_a) {
    var _b = _a.data, currentPieData = _b.currentPieData, startYearPieData = _b.startYearPieData, currentWeekCount = _b.currentWeekCount, startYearDate = _b.startYearDate, grade = _b.grade, onDiagramHover = _a.onDiagramHover, rest = __rest(_a, ["data", "onDiagramHover"]);
    var legend = legends.get(grade);
    var getPieDataCombinedByTestPosition = useCallback(function (pieData) {
        var updatedPieData = pieData
            .filter(function (d) { return d.value > 0; })
            .map(function (data) {
            var _a;
            var newColor = (_a = legend === null || legend === void 0 ? void 0 : legend.find(function (l) { return l.grade === data.id; })) === null || _a === void 0 ? void 0 : _a.color;
            return __assign(__assign({}, data), { color: newColor });
        });
        var updatedPieDataMappedByColor = new Map();
        updatedPieData.forEach(function (_a) {
            var _b;
            var color = _a.color, students = _a.students, label = _a.label, id = _a.id;
            var previous = (_b = updatedPieDataMappedByColor.get(color)) !== null && _b !== void 0 ? _b : {
                students: [],
            };
            var updatedStudents = __spreadArray(__spreadArray([], previous === null || previous === void 0 ? void 0 : previous.students, true), students, true);
            var updatedValue = updatedStudents.length;
            updatedPieDataMappedByColor.set(color, __assign(__assign({}, previous), { label: label, id: id, students: updatedStudents, value: updatedValue }));
        });
        var pieDataCombinedByColor = Array.from(updatedPieDataMappedByColor, function (_a) {
            var color = _a[0], restData = _a[1];
            return (__assign({ color: color }, restData));
        });
        return pieDataCombinedByColor;
    }, [legend]);
    var startYearPieDataCombinedByTestPosition = getPieDataCombinedByTestPosition(startYearPieData);
    var currentPieDataCombinedByTestPosition = getPieDataCombinedByTestPosition(currentPieData);
    return (_jsxs(Container, __assign({}, rest, { children: [_jsx(TitleContainer, { children: _jsxs(Title, { children: ["Class Distribution", _jsx(Tooltip, __assign({ content: "Class distribution by working grade\n                level at the start of the program\n                and at the current point", maxWidth: 'none' }, { children: _jsx(HelpIcon, { "data-testid": 'tooltip' }, void 0) }), void 0)] }, void 0) }, void 0), _jsxs(Body, { children: [_jsxs(LeftPart, { children: [_jsx(ScSubHeader, { children: "Beginning of the year" }, void 0), _jsx(InfoText, __assign({ "data-testid": 'start-date' }, { children: format(startYearDate, 'MMMM yyyy') }), void 0), _jsx(PieContainer, __assign({ onMouseEnter: onDiagramHover }, { children: _jsx(PieBase, { data: startYearPieDataCombinedByTestPosition, legend: { position: 'none', colors: legend }, width: 188, prefix: 'beginOfYear' }, void 0) }), void 0)] }, void 0), _jsxs(RightPart, { children: [_jsx(ScSubHeader, { children: "Current" }, void 0), _jsx(InfoText, __assign({ "data-testid": 'current-date' }, { children: "~ " + currentWeekCount + " weeks of practice" }), void 0), _jsx(PieContainer, __assign({ onMouseEnter: onDiagramHover }, { children: _jsx(PieBase, { data: currentPieDataCombinedByTestPosition, legend: { position: 'none', colors: legend }, width: 188, prefix: 'current' }, void 0) }), void 0)] }, void 0)] }, void 0), _jsx(LegendContainer, { children: legend && (_jsx(CommonLegend, { legend: legend.filter(function (l) {
                        return currentPieData.some(function (d) { return d.id === l.grade && d.value > 0; }) ||
                            startYearPieData.some(function (d) { return d.id === l.grade && d.value > 0; });
                    }) }, void 0)) }, void 0)] }), void 0));
};
export { DiagramDistribution };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;
